/*
 * @Author: heyuan
 * @Date: 2020-08-19 16:41:57
 * @LastEditors: heyuan
 * @LastEditTime: 2020-08-19 17:44:26
 * @FilePath: \program-name\src\net\home\index.js
 */
import {get,post} from "../Api.js";
import config from "../config";
import {getCookie} from '../../untils/common.js'
import axios from 'axios'
const {baseUrl} = config
// 登录
function ApiLogin (params) {
  return post(`${baseUrl}student/login`, params);
}

// 登录后获取所属公司信息
function ApiGetCompanyInfo (params) {
  return post(`${baseUrl}student/getCompanyInfo`, params);
}

// 获取验证码
function ApiSendTelCode (params) {
  return post(`${baseUrl}common/sendTelCode`, params);
}

// 校验验证码
function ApiCheckTelCode (params) {
  return post(`${baseUrl}common/checkTelCode`, params);
}

// 忘记密码
function ApiForgetPassword (params) {
  return post(`${baseUrl}common/forgetPassword`, params);
}

// 轮播图
function ApiGetBanner (params) {
  return get(`${baseUrl}banner/list`, params);
}

// 首页重点课程分类
function ApiGetKeyCategory (params) {
  return post(`${baseUrl}course/keyCategory`, params);
}

// 首页任务列表 (前三个)
function ApiGetHomeTask (params) {
  return post(`${baseUrl}task/homeTask`, params);
}

// 首页课程6要素
function ApiGetCategory (params) {
  return get(`${baseUrl}course/category`, params);
}

// 课程列表 根据6要素和子要素 重点分类 获取课程
function ApiGetCategoryCourse (params) {
  return post(`${baseUrl}course/categoryCourse`, params);
}

// 首页消息列表
function ApiGetMsgList (params) {
  return post(`${baseUrl}student/message`, params);
}

// 消息详情
function ApiGetMsgDetail (params) {
  return get(`${baseUrl}student/messageDetail`, params);
}
// 外链功能查询
function ApiGetLinks (params) {
  return post(`${baseUrl}links/list`, params);
}
// 积分上传接口
function ApiPointsOrder (params) {
  return post(`${baseUrl}points/order/`, params);
}
// code免登录
function ApiGetLoginInfoByCode (params) {
  return post(`${baseUrl}oauth/getLoginInfo`, params);
}
export {
	ApiLogin,
  ApiGetCompanyInfo,
	ApiSendTelCode,
  ApiCheckTelCode,
  ApiForgetPassword,
  ApiGetBanner,
  ApiGetKeyCategory,
  ApiGetHomeTask,
  ApiGetCategory,
  ApiGetCategoryCourse,
  ApiGetMsgList,
  ApiGetMsgDetail,
  ApiGetLinks,
  ApiPointsOrder,
  ApiGetLoginInfoByCode
}



// WEBPACK FOOTER //
// ./src/net/home/index.js